export const Message = 'message'

export const Error = 'error'
